import { NextResponse, type NextRequest } from 'next/server'
import { LOCALE, LANGUAGES } from './utils'

function validateBasicAuth(header) {
  const authValue = header.split(' ')[1]
  const [user, pwd] = atob(authValue).split(':')
  return (user === process.env.BASIC_AUTH_USER && pwd === process.env.BASIC_AUTH_PASSWORD)
}

export function getLocaleFromPathname(pathname: string): string | null {
  return LANGUAGES.find(locale => pathname.startsWith(`/${locale}/`) || pathname === `/${locale}`) || null
}

export default async function proxy(req: NextRequest) {
  const nextUrl = req.nextUrl

  // BASIC AUTH
  // ==============================
  const basicAuthRequired = process.env.BASIC_AUTH_REQUIRED === 'true'
  const basicAuthHeader = req.headers.get('authorization') || req.headers.get('Authorization')
  const basicAuthPassed = !basicAuthHeader ? false : validateBasicAuth(basicAuthHeader)

  if (basicAuthRequired && !basicAuthPassed) {
    nextUrl.pathname = '/api/auth/basic'
    return NextResponse.rewrite(nextUrl)
  }
  // END BASIC AUTH


  // I18N
  // ==============================
  // Check if there is any supported locale in the pathname
  const { pathname } = req.nextUrl
  // Function to check if the pathname has any locale
  const localeFromPathname = getLocaleFromPathname(pathname)

  // If the pathname has no locale, rewrite to the default locale
  if (!localeFromPathname) {
    const response = NextResponse.rewrite(
      new URL(`/${LOCALE}${pathname.startsWith('/') ? '' : '/'}${pathname}`, req.nextUrl),
    )

    const searchParams = req.nextUrl.searchParams.toString()
    if (searchParams) response.headers.set('x-search-params', searchParams)

    return response
  }
  // END I18N

  const response = NextResponse.next()
  const searchParams = req.nextUrl.searchParams.toString()
  if (searchParams) response.headers.set('x-search-params', searchParams)
  return response
}


/**
 * Match all request paths except for:
 * - api (API routes)
 * - _next/static (files in static folder)
 * - _next/image  (image optimization files)
 * - .well-known folder
 * - images folder
 * - videos folder
 * - docs folder
 * - favicon.ico
 * - robots.txt
 * - sitemap.xml
 * - manifest.json
 * - .ttf files
 * - .woff2 files
 * - .svg files
 * - .jpg files
 * - .png files
**/
export const config = {
  matcher: [
    '/((?!api|_next/static|_next/image|.well-known|images|videos|docs|favicon.ico|robots.txt|sitemap.xml|manifest.json|manifest.webmanifest|.*\\.ttf|.*\\.woff2|.*\\.svg|.*\\.jpg|.*\\.png$).*)',
  ]
}
